import React, { useState } from "react";
import "./Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    service: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // TODO: Replace with API call
    // Example:
    // await axios.post("/api/contact", formData);

    alert("Thank you! Your message has been sent successfully.");

    setFormData({
      name: "",
      email: "",
      phone: "",
      company: "",
      service: "",
      message: "",
    });
  };

  return (
    <div className="contact">

      {/* HERO SECTION */}
      <div className="contact-hero">
        <div className="container">
          <h1 className="contact-title">Get In Touch</h1>
          <p className="contact-subtitle" id="contact-subtitleid">
            We'd love to hear from you. Let’s discuss your project.
          </p>
        </div>
      </div>

      {/* MAIN CONTENT */}
      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">

            {/* FORM SECTION */}
            <div className="contact-form-section">
              <h2>Send us a Message</h2>
              <p>Fill out the form and our team will contact you shortly.</p>

              <form className="contact-form" onSubmit={handleSubmit}>

                {/* Row 1 */}
                <div className="form-row">
                  <div className="form-group">
                    <label>Full Name *</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Email *</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                {/* Row 2 */}
                <div className="form-row">
                  <div className="form-group">
                    <label>Phone</label>
                    <input
                      type="text"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>Company</label>
                    <input
                      type="text"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                {/* Service */}
                <div className="form-group">
                  <label>Service</label>
                  <select
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    <option value="Web Development">Web Development</option>
                    <option value="Mobile App Development">Mobile App Development</option>
                    <option value="Cloud Solutions">Cloud Solutions</option>
                    <option value="IT Support">IT Support</option>
                    <option value="Hostel Management Software">Hostel Management Software</option>
                    <option value="POS Billing Software">POS Billing Software</option>
                    <option value="ERP / CRM System">ERP / CRM System</option>
                    <option value="Custom Management System">Custom Management System</option>
                  </select>
                </div>

                {/* Message */}
                <div className="form-group">
                  <label>Message *</label>
                  <textarea
                    name="message"
                    rows="6"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </div>

                <button type="submit" className="submit-btn">
                  Send Message
                </button>

              </form>
            </div>

            {/* CONTACT INFO SECTION */}
            <div className="contact-info-section">
              <h2>Contact Information</h2>

              <div className="contact-info-grid">

                <div className="contact-info-card">
                  <div className="info-icon">📍</div>
                  <h3>Address</h3>
                  <p>
                    <a
                      href="https://www.google.com/maps?q=LogicSphere+Technologies+Pvt+Ltd+Sadashiv+Peth+Pune"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="contact-link"
                    >
                      LogicSphere Technologies Pvt Ltd, Office no 107,
                      Orchid Complex, Bajirao Rd, Sadashiv Peth,
                      Pune, Maharashtra 411030
                    </a>
                  </p>
                </div>

                <div className="contact-info-card">
                  <div className="info-icon">📞</div>
                  <h3>Phone</h3>
                  <p>
                    <a href="tel:+917796986889" className="contact-link">
                      +91 7796986889
                    </a>
                    <br />
                    Mon–Fri: 9AM–6PM
                  </p>
                </div>

                <div className="contact-info-card">
                  <div className="info-icon">✉️</div>
                  <h3>Email</h3>
                  <p>
                    <a href="mailto:hr@logicspheretechnologies.com" className="contact-link">
                      hr@logicspheretechnologies.com
                    </a>
                    <br />
                    <a href="mailto:support@logicspheretechnologies.com" className="contact-link">
                      support@logicspheretechnologies.com
                    </a>
                  </p>
                </div>

                <div className="contact-info-card">
                  <div className="info-icon">🕒</div>
                  <h3>Business Hours</h3>
                  <p>
                    Monday – Friday: 9:00 AM – 6:00 PM
                    <br />
                    Saturday: 10:00 AM – 4:00 PM
                  </p>
                </div>

                <div className="contact-info-card">
                  <div className="info-icon">🇺🇸</div>
                  <h3>US Client Support</h3>
                  <p>
                    Flexible overlap with EST / CST / PST
                    <br />
                    Dedicated project communication
                  </p>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
};

export default Contact;